import React from 'react';
import FormInput from "../../../Components/Forms/FormInput";
import {ISA_TYPES, OPENING_OR_TRANSFERRING} from "../../../constants";
import SecondaryTitle from "../../../Components/SecondaryTitle";

const TransferringIsaDetails = (props) => {
    const {
        data = {
            'isa_type':                                      '',
            'isa_amount':                                    '',
            'current_isa_reference_number':                  '',
            'current_isa_manager':                           '',
            'current_isa_manager_address':                   '',
            'current_isa_transfer_date_requested':           '',
            'current_isa_first_subscription_current_year':   '',
            'opening_or_transferring':                       '',
        },
        errors      = null,
        onChange    = (field, value) => {},
        disabled    = false
    } = props;

    const handleAmountChange = (value) => {
        const newValue = `£${value.replace(/[^0-9.]/g, '')}`;
        onChange('isa_amount', newValue);
    };

    return (
        <React.Fragment>
            <SecondaryTitle>Transferring</SecondaryTitle>
            <div className={'row m-0 p-0'}>
                <div className={'col-12 col-md-6 m-0 p-0 pe-md-2'}>
                    <FormInput
                        required={true}
                        name={'isa_type'}
                        detailedLabel={'Type of ISA'}
                        value={data.isa_type}
                        type={'select'}
                        options={ISA_TYPES}
                        onChange={(value) => onChange('isa_type', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 ps-md-2'}>
                    <FormInput
                        required={true}
                        name={'isa_amount'}
                        detailedLabel={'Amount'}
                        value={data.isa_amount}
                        type={'text'}
                        onChange={handleAmountChange}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 pe-md-2'}>
                    <FormInput
                        required={true}
                        name={'current_isa_reference_number'}
                        detailedLabel={'ISA reference number'}
                        value={data.current_isa_reference_number}
                        type={'text'}
                        onChange={(value) => onChange('current_isa_reference_number', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 ps-md-2'}>
                    <FormInput
                        required={true}
                        name={'current_isa_manager'}
                        detailedLabel={'Current ISA manager'}
                        value={data.current_isa_manager}
                        type={'text'}
                        onChange={(value) => onChange('current_isa_manager', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 pe-md-2'}>
                    <FormInput
                        required={true}
                        name={'current_isa_manager_address'}
                        detailedLabel={'Current ISA manager address'}
                        value={data.current_isa_manager_address}
                        type={'text'}
                        onChange={(value) => onChange('current_isa_manager_address', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 ps-md-2'}>
                    <FormInput
                        required={true}
                        name={'current_isa_transfer_date_requested'}
                        detailedLabel={'Date transfer request'}
                        value={data.current_isa_transfer_date_requested}
                        type={'date'}
                        onChange={(value) => onChange('current_isa_transfer_date_requested', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 pe-md-2'}>
                    <FormInput
                        required={true}
                        name={'current_isa_first_subscription_current_year'}
                        detailedLabel={'Date of first subscription in current year'}
                        value={data.current_isa_first_subscription_current_year}
                        type={'date'}
                        onChange={(value) => onChange('current_isa_first_subscription_current_year', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
            </div>
        </React.Fragment>
    );
}

export default TransferringIsaDetails;
